<template>
  <span class="p-d-inline-flex"
        v-tooltip.left="billingActionTooltipOptions(
          allowWhenBillingLocked,
          tooltip
        )">
    <Button v-bind="$attrs"
            :disabled="disabled || billingActionIsRestricted(allowWhenBillingLocked)"
            :label="label"
            icon="ti-check"
            class="p-button-success p-button-raised"/>
  </span>
</template>

<script>
import billingRestrictionsMixin from '@/mixins/billingRestrictionsMixin'

export default {
  name: 'AcceptButton',
  inheritAttrs: false,
  mixins: [billingRestrictionsMixin],

  props: {
    label: String,

    disabled: {
      type: Boolean,
      default: false,
    },

    allowWhenBillingLocked: {
      type: Boolean,
      default: false,
    },

    tooltip: {
      type: String,
      default: '',
    },
  },
}
</script>
